import { render, staticRenderFns } from "./ViewProperty.vue?vue&type=template&id=0211b1e1"
import script from "./ViewProperty.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewProperty.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports